module.exports = __webpack_public_path__ + "static/media/angle1.c0dd7940.svg";